import moment from 'moment-timezone';
import Request from 'files/Request.js';

class AccountClass {

    // optional resources
    supported_actions = null;

    // required values
    active = true;
    authentication = null;
    authentication_method = null;
    category = null;
    config = null;
    created = null;
    id = null;
    last_updated_date = null;
    management_enabled = null;
    metadata = null;
    name = null;
    notes = null;
    provider = null;
    
    constructor() {
        return this;
    }

	create = (props = {}) => {
        this.active = props.active;
        this.authentication = props.authentication;
        this.authentication_method = props.authentication_method;
        this.category = props.category;
        this.config = props.config;
        this.created = props.created && moment.utc(props.created).local();
        this.id = props.id;
        this.last_updated_date = props.last_updated_date && moment.utc(props.last_updated_date).local();
        this.management_enabled = props.management_enabled;
        this.metadata = props.metadata;
        this.name = props.name;
        this.notes = props.notes;
        this.provider = props.provider;
        this.supported_actions = props.supported_actions;
        return this;
	}
}

export const fetchAccount = async (utils, id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { account } = await Request.get(utils, '/accounts/', {
                id: id,
                type: 'details'
            });
            resolve(new AccountClass().create(account));
        } catch(e){
            reject(e);
        }
    });
}

export default {
    create: props => new AccountClass().create(props),
    get: fetchAccount,
    new: () => new AccountClass()
}
